module.exports = __webpack_public_path__ + "static/img/specific_6.cdca40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/specific_6.png
// module id = mMGu
// module chunks = 16